// extracted by mini-css-extract-plugin
export default {"title":"zfCg4","grid":"rPUqF","one-column-mobile":"_1taYI","oneColumnMobile":"_1taYI","mobile":"LKFf6","minimal":"jWHGa"};